/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "warning-knockout-5f6bd260--sprite",
  "use": "warning-knockout-5f6bd260--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"warning-knockout-5f6bd260--sprite\"><g transform=\"translate(8886.697 17834.959)\"><g transform=\"translate(-8880.697 -17827.959)\"><path d=\"M-173.475,252.812l-1.279-2.345-8.339-15.33a1.966,1.966,0,0,0-1.319-.986,1.969,1.969,0,0,0-1.188.108,1.353,1.353,0,0,0-.185.086,2.034,2.034,0,0,0-.792.792l-7.5,13.781-2.12,3.893a1.986,1.986,0,0,0,.8,2.691,1.934,1.934,0,0,0,.945.243h19.237a1.985,1.985,0,0,0,1.984-1.985A2.018,2.018,0,0,0-173.475,252.812Zm-11.36-11.454a.991.991,0,0,1,.99.995l-.495,5.5a.494.494,0,0,1-.5.5.494.494,0,0,1-.5-.5l-.495-5.5A.991.991,0,0,1-184.836,241.357Zm.7,10.631a.989.989,0,0,1-.7.293.99.99,0,0,1-.7-.293,1,1,0,0,1-.288-.7,1.007,1.007,0,0,1,.288-.7.99.99,0,0,1,.7-.293,1,1,0,0,1,.995.995A.979.979,0,0,1-184.134,251.988Z\" transform=\"translate(196.436 -234.105)\" fill=\"currentColor\" /></g></g><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
